<mat-radio-group
  class="collect-payment-radio-group"
  [ngModel]="requireApproval"
  (ngModelChange)="requireApprovalChange.emit($event)"
  *ngIf="users; else loading"
  (change)="trackToggle($event)"
>
  <div class="collection-options">
    <mat-radio-button data-action="confirm-order-dont-collect-payment" [value]="false">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.DONT_NEED_TO_COLLECT' | translate }}
    </mat-radio-button>
    <mat-radio-button data-action="confirm-order-collect-payment" [value]="true">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.SEND_ORDER_TO_CUSTOMER' | translate }}
    </mat-radio-button>
  </div>
  <div class="row row-gutters approval-options" *ngIf="requireApproval; else noApprovalNotice">
    <div class="col col-xs-12 col-sm-6 hide-form-field-padding">
      <mat-form-field class="select-user" appearance="outline">
        <mat-label>
          {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.SELECT_USER' | translate }}
        </mat-label>
        <mat-select [value]="selectedUserId$ | async" (valueChange)="subjectIdChange.emit($event)">
          <mat-option *ngIf="users" (click)="presentAddUsersDialog()">
            <mat-icon>add</mat-icon>
            {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.ADD_USERS' | translate }}
          </mat-option>
          <mat-option *ngFor="let user of users" [value]="user.userId" (mousedown)="preventBlur($event)">
            {{ user | userDisplayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col col-xs-12 col-sm-6 align-center">
      <mat-checkbox [ngModel]="hasExpiryDate" (ngModelChange)="hasExpiryDateChange.emit($event)">
        {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.ADD_EXPIRY_DATE' | translate }}
      </mat-checkbox>
    </div>
    <ng-container *ngIf="hasExpiryDate">
      <div class="col col-xs-12 col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>
            {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.SELECT_DATE' | translate }}
          </mat-label>
          <input
            matInput
            readonly
            [matDatepicker]="picker"
            name="date"
            [min]="minDate"
            [ngModel]="expiryDate"
            (ngModelChange)="handleExpiryDateChange($event)"
            (click)="picker.open()"
            required
          />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #picker [touchUi]="false"></mat-datepicker>
      </div>
      <div class="col col-xs-12 col-sm-6">
        <forms-time-picker
          [control]="expiryTimeControl"
          appearance="outline"
          label="{{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.SELECT_TIME' | translate }}"
        ></forms-time-picker>
      </div>
      <div class="col col-xs-12">
        <ng-container *ngFor="let user of users">
          <div class="notice" *ngIf="user.userId === subjectId">
            {{
              'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.EXPIRY_NOTICE'
                | translate
                  : {
                      name: user.name || user.email,
                      date: expiryDate | date: 'MMMM d, yyyy',
                      time: expiryDate | date: 'h:mm a',
                    }
            }}
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-template #noApprovalNotice>
    <div class="notice">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.DONT_NEED_TO_COLLECT_NOTICE' | translate }}
    </div>
  </ng-template>
</mat-radio-group>
<ng-template #loading>
  <div class="stencil-shimmer"></div>
  <div class="stencil-shimmer"></div>
</ng-template>
